// extracted by mini-css-extract-plugin
export default {"weekNames":"calendar_weekNames__-u2Xi","calendarDays":"calendar_calendarDays__Sd0xQ","wrapper":"calendar_wrapper__LmDYl"};